import { useState } from 'react';
import { ProtocolMetaFields } from '../../components/protocol-form/protocolMetaFields.tsx';
import { ProtocolFinal } from '../../types/sharedTypeImpl.ts';
import { trpc } from '../../utils/trpc/trpc.ts';


interface Props {
    equipment: string;
    protocol: ProtocolFinal;
    enabledIssues: number | undefined;
    allIssues: number | undefined;
}

export function Overview({
    equipment,
    protocol,
    enabledIssues,
    allIssues,
}: Props) {
    const [isCollapsed, setIsCollapsed] = useState(true);

    const { data: equipmentData } = trpc.equipments.getCncById.useQuery(equipment);

    const issuesText = enabledIssues != null && allIssues != null
        ? `${enabledIssues} / ${allIssues}`
        : '';

    return (
        <table className='record-form--table'>
            <tbody>
                {!isCollapsed && <ProtocolMetaFields
                    protocol={protocol}
                    disabled={true}
                />}
                {isCollapsed && <tr>
                    <td>Part number</td>
                    <td><input type='text' value={protocol?.partDisplayName ?? ''} disabled /></td>
                </tr>}
                <tr>
                    <td>Equipment</td>
                    <td><input type='text' value={equipmentData?.displayName ?? ''} disabled /></td>
                </tr>
                {!isCollapsed && <tr>
                    <td>Issues</td>
                    <td><input type='text' value={issuesText} disabled /></td>
                </tr>}
                <tr>
                    <td colSpan={2}>
                        <button onClick={() => setIsCollapsed(!isCollapsed)} >
                            {isCollapsed ? 'Show more' : 'Show less'}
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    );
}
